import Component from 'vue-class-component'
import moduleStore from '../store/index'
import Vue from 'vue'
import PageState from '../store/state'
import { toast } from '@/utils/util'
import { judgeDeviceType } from '@/utils/device'

@Component({
    components: {
    }
})
@moduleStore.initVuex({
    mutationNames: moduleStore.mutationNames,
    actionNames: moduleStore.actionNames
})
export default class DuplicateRemoval extends Vue {
  state = new PageState();
  // 分类
  tabList = [
    {
      name: '短视频链接',
      type: 'link'
    },
    {
      name: '视频文件MP4',
      type: 'mp4'
    },
  ]
  // 当前类型
  activeTabType = 'link'

  link = ''
  uploadRef = null
  // 文件信息
  fileInfo = null
  // 是否上传中
  isUpload = false
  isApp = judgeDeviceType.isAPP
  // 是否正在请求
  isRequest = false
  videoUrl = ''
  // 是否显示重新上传
  get showRestBtn() {
    if (this.fileInfo && this.activeTabType === 'mp4') {
        return true
    }
    return false
  }
  mounted() {
    this.getLocalStorageInputContent()
    setTimeout(() => {
      this.uploadRef = this.$refs.uploadRef as any;
      console.log('uploadRef', this.uploadRef);
    }, 800)
  }
  /**
   * 切换tab
   * @param type
   */
  changeTab(type: string) {
    this.activeTabType = type
  }
  handleSelectClick() {
    this.uploadRef.click()
  }
  /**
   * 选择文件
   * @param e
   */
  changeFile(e) {
   const file = e.target.files[0]
   const maxLength = 300 * 1024 * 1024
   if (file.size > maxLength) {
    toast('请上传大小不超过300M文件')
    return
   }
   this.isUpload = true
   file.sizeDesc = (file.size / 1024 / 1024).toFixed(2) + 'M'
   this.loadVideo(file)
   this.uploadRef.value = ''
  }
  async pasteTxt() {
    if (this.isApp) {
      let getClipBordContent: any = (<any>window).getClipBordContent;
      getClipBordContent.postMessage('');
    } else {
      // toast("请点击输入框，长按粘贴内容")
      try {
        let cptext = await navigator.clipboard.readText();
        this.link = cptext
      } catch (error) {
        toast("请点击输入框，长按粘贴内容");
        console.log('粘贴出错:', error);
      }
    }
  }
  /**
   * 跳转新手教程
   */
  toVideoTutorial() {
    const videoUrl = 'https://tc-nj-backend-pub-cdn.mobvoi.com/subtitles/mp4/e419b8a84e23ed43c8c7ad3cd5817fea.mp4'
    const coverUrl = 'https://tc-nj-backend-pub-cdn.mobvoi.com/subtitles/jpeg/e415aab05cf641ffe0d302594d93b40c.jpeg'
    this.$navigateTo({
      url: '/baohuo-package/pages/video-play/video-play?videoUrl=' + videoUrl + '&coverUrl=' + coverUrl,
    })
  }
  /**
   * 开始去重
   */
  confirmDuplicate() {
    if (this.isRequest) return
    const ww_token = localStorage.getItem('ww_token')
    if (!ww_token) {
      this.toLoginPage()
      return
    }
    if (this.activeTabType === 'link' && !this.link) {
        toast('请输入或粘贴视频链接')
        return 
    }
    if (this.activeTabType === 'mp4' && !this.fileInfo) {
        toast('请上传视频文件')
        return 
    }
    console.log('开始去重', this.fileInfo)
    this.isRequest = true
    let timer = setTimeout(() => {
        this.isRequest = false
        clearTimeout(timer)
        timer = null
    }, 1000)
  }
  /** 跳转到登录页 */
  toLoginPage() {
    localStorage.setItem('AI_duplicate_input_content', JSON.stringify({
      text: this.link,
      videoUrl: '',
      fileInfo: this.fileInfo,
      type: this.activeTabType
    }))
    this.$redirectTo({
      url: `/pages/login/login?from=${ 'AITool' }&redirect=${ '/package-tools/pages/ai-duplicate-removal/ai-duplicate-removal' }&timestamp=${ new Date().getTime() }`
    })
  }
  /** 登录返回时获取 localStorage 存储的表单输入内容 */
  getLocalStorageInputContent() {
    const inputContent = localStorage.getItem('AI_duplicate_input_content')
    if (inputContent) {
      const { text, type, videoUrl, fileInfo } = JSON.parse(inputContent)
      this.link = text
      this.activeTabType = type
      this.fileInfo = fileInfo
      this.videoUrl = videoUrl
      // 清除存储的数据
      localStorage.removeItem('AI_duplicate_input_content')
    }
  }
  /**
   * 加载视频信息
   */
  loadVideo(file) {
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.src = URL.createObjectURL(file)
    video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src) // 释放URL对象
        file.durationDesc = this.handleDuration(video.duration)
        this.fileInfo = file
        let timer = setTimeout(() => {
            this.isUpload = false
            clearTimeout(timer)
            timer = null
        }, 1000)
        
    }
  }
  handleDuration(duration) {
    if (duration < 60) {
        return duration + '秒'
    } else if (duration >= 60 && duration < 3600) {
        return Math.floor(duration / 60) + '分' + Math.floor(duration % 60) + '秒'
    } else {
        return Math.floor(duration / 3600) + '小时' + Math.floor((duration % 3600) / 60) + '分' + Math.floor(duration % 60) + '秒'
    }
  }

}